import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date: &nbsp;23-Dec-2025</strong></p>

        <p>
          This Privacy Policy explains how 
          <strong> MITHA CONSTRUCTION AND DEVELOPMENT</strong>
          ("we", "our", "us") collects, uses, and protects your personal information when you visit or use our website 
          <strong> www.mithahomes.com</strong>.
        </p>

        <p>
          By accessing or using this Website, you agree to the terms outlined in this Privacy Policy.
        </p>

        <h2>1. Information We Collect</h2>
        <p><strong>a. Personal Information</strong></p>
        <p>We may collect personal information when you voluntarily provide it, including:</p>
        <ul style={styles.list}>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Address</li>
          <li>Any other information you choose to submit</li>
        </ul>

        <p><strong>b. Non-Personal Information</strong></p>
        <p>We may automatically collect non-personal data such as:</p>
        <ul style={styles.list}>
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device information</li>
          <li>Pages visited and duration</li>
          <li>Referring website URLs</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>Your information may be used to:</p>
        <ul style={styles.list}>
          <li>Respond to inquiries and service requests</li>
          <li>Provide updates about projects or services</li>
          <li>Improve our website and user experience</li>
          <li>Maintain internal records</li>
          <li>Comply with legal or regulatory requirements</li>
        </ul>

        <h2>3. Cookies and Tracking Technologies</h2>
        <p>
          Our Website may use cookies and similar technologies to enhance functionality and analyze traffic.
          You can disable cookies in your browser settings, though some features may not function properly.
        </p>

        <h2>4. Information Sharing and Disclosure</h2>
        <p>
          We do not sell, trade, or rent your personal information to third parties. Information may be shared only:
        </p>
        <ul style={styles.list}>
          <li>With trusted service providers under confidentiality agreements</li>
          <li>When required by law or legal process</li>
          <li>To protect our rights, property, or safety</li>
        </ul>

        <h2>5. Data Security</h2>
        <p>
          We use reasonable administrative, technical, and physical safeguards to protect your personal data.
          However, no online data transmission is completely secure.
        </p>

        <h2>6. Third-Party Links</h2>
        <p>
          Our Website may contain links to external websites. We are not responsible for the privacy practices
          or content of those sites.
        </p>

        <h2>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul style={styles.list}>
          <li>Access your personal information</li>
          <li>Request correction or deletion of your data</li>
          <li>Withdraw consent, subject to legal obligations</li>
        </ul>

        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be effective once posted on this page.
          We encourage users to review this policy periodically.
        </p>

        <h2>9. Contact Information</h2>
        <p>
          If you have any questions regarding this Privacy Policy, please contact us:
        </p>
        <p>
          <strong>MITHA CONSTRUCTION AND DEVELOPMENT</strong><br/>
          Website: www.mithahomes.com<br/>
          Email: [Insert Official Email Address]<br/>
          Phone: [Insert Contact Number]
        </p>

        <p style={styles.footerNote}>
          © 2025 MITHA CONSTRUCTION AND DEVELOPMENT. All rights reserved.
        </p>
      </div>
    </div>
  );
};

const styles = {
  body: {
    fontFamily: "'Arial', 'Helvetica', sans-serif",
    backgroundColor: '#f0f9f0', // Light green background
    color: '#1a331a', // Dark green text
    margin: 0,
    padding: 0,
    lineHeight: 1.7,
    minHeight: '100vh',
  },
  container: {
    maxWidth: '1000px',
    margin: '30px auto',
    background: '#ffffff',
    padding: '30px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    borderTop: '5px solid #2e7d32', // Green accent border
  },
  list: {
    marginLeft: '20px',
    paddingLeft: '0',
  },
  footerNote: {
    marginTop: '30px',
    fontSize: '14px',
    color: '#4a6c4a', // Medium green for footer
    borderTop: '1px solid #c8e6c9', // Light green border
    paddingTop: '15px',
  },
};

// For the headings, we'll add CSS via a style tag
const HeadingsStyle = () => (
  <style>{`
    h1, h2 {
      color: #1b5e20; /* Dark green for headings */
    }
    h1 {
      font-size: 28px;
      margin-bottom: 10px;
      border-bottom: 2px solid #81c784; /* Light green underline */
      padding-bottom: 10px;
    }
    h2 {
      font-size: 20px;
      margin-top: 25px;
      color: #2e7d32; /* Medium green for subheadings */
    }
    strong {
      color: #1b5e20; /* Dark green for bold text */
    }
    li {
      margin-bottom: 8px;
      color: #2e3f2e; /* Slightly lighter green for list items */
    }
    p {
      margin: 10px 0;
    }
  `}</style>
);

const PrivacyPolicyWithStyles = () => (
  <>
    <HeadingsStyle />
    <PrivacyPolicy />
  </>
);

export default PrivacyPolicyWithStyles;